import { Component, OnInit, ViewChild } from '@angular/core';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatSort } from '@angular/material/sort';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { ListMunicipalitiesService } from './list-municipalities.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { MunicipalitiesService } from '../municipalities.service';
import { ActivatedRoute, Router } from '@angular/router';

export interface Element {
  position: number;
  name: string;
  weight: number;
  symbol: string;
}

@Component({
  selector: 'app-list-municipalities',
  templateUrl: './list-municipalities.component.html',
  styleUrls: ['./list-municipalities.component.scss']
})
export class ListMunicipalitiesComponent implements OnInit {


  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;


  displayedColumns: string[] = ['region', 'municipality', 'manager', 'email', 'buttons'];
  dataSource: MatTableDataSource<any>;


  constructor(
    private toast: ToastrService,
    private translate: TranslateService,
    private municipalitiesService: MunicipalitiesService,
    private router: Router,
    private activatedRoute: ActivatedRoute,


  ) { }

  ngOnInit() {
    // this.dataSource = new MatTableDataSource([]);

    const rowData = [];

    console.log("list comp!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!");
    console.log("list comp!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!");
    console.log("list comp!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!");
    console.log("list comp!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!");


    this.municipalitiesService.getAllMunicipalities().subscribe(municipalities => {

      for (let municipality of municipalities) {
        console.log("municipality 111");
        console.log(municipality);


        rowData.push(
          {
            region: municipality.city.administrative_region,
            municipality: municipality.city.municipality,
            manager: ` ${municipality.account[0].name} ${municipality.account[0].surname}`,
            email: municipality.account[0].email,
            id: municipality.city._id
          });
      }

      this.dataSource = new MatTableDataSource(rowData);
      console.log("Fetched municipalities data:", rowData);


      this.paginator._intl.itemsPerPageLabel = '';
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }, error => {
      this.toast.error(this.translate.instant('Error fetching municipalities'));
    });




  }

  fetchAllMunicipulities() {
    return this.municipalitiesService.getAllMunicipalities();
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }



  // material navigate button
  getRecordInfo(row) {
    console.log('my row');
    console.log(row);
    this.router.navigate([row.id], { relativeTo: this.activatedRoute });
  }
  getRecordEdit(row) {
    this.router.navigate([row.id, 'edit'], { relativeTo: this.activatedRoute });
  }

}
